interface SvgInterface {
    className?: string;
    onClick?: () => void;
}
export function TriangleDownIcon({className = '', onClick = () => {}}: SvgInterface) {
    return <svg onClick={onClick} className={className} fill="none" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M4 6H11L7.5 10.5L4 6Z" fill="currentColor"/></svg>;
}